// Imports from respective modules
import  { DataProcessing, PDS, Preferences }  from "@mydex/pds-adaptor-frontend";
import  { MRD, Lists }  from "@mydex/mrd-adaptor-frontend";
import  { InAppDatasets, ClientList }  from "@mydex/inapp-datasets";
import  { Util, Validation }   from "@mydex/utils";
import  { Dashboard }   from "@mydex/dashboards";
import  {
  Calendar,
  Card,
  Referral,
  Timeline,
  Register,
  Group,
  Table,
  MaMMenu,
  CheckButtonsMulti,
  ListAddItems,
  MyPeople,
  ProfilePicWideWControls,
  FileDropper,
  MySupportPackages,
  PhoneEntry,
  ExpandableCard,
  MedicalInformation,
  MyHealthConditions,
  AddressBook,
  GalleryUploader,
  MaMFormHandler,
  PDSTable,
  Export,
  Forms,
  MFA,
  ProfileImage,
  PasswordReset,
  PrivateKeyChange,
  RemoveConnection,
  Account,
  Timezone,
  Timeout,
  PasswordChange

}
from "@mydex/mydex-design-system";

// Loads code into the window context so can be references anywhere
window.DataProcessing = DataProcessing;
window.PDS = PDS;
window.Preferences = Preferences;
window.MRD = MRD;
window.Lists = Lists;
window.InAppDatasets = InAppDatasets;
window.Util = Util;
window.Validation = Validation;
window.Dashboard = Dashboard;
window.Register = Register;
window.Group = Group;
window.Table = Table;
window.ClientList = ClientList;
window.AddressBook = AddressBook;
window.GalleryUploader = GalleryUploader;
window.MaMFormHandler = MaMFormHandler;
window.MySupportPackages = MySupportPackages;
window.MedicalInformation = MedicalInformation;
window.MyHealthConditions = MyHealthConditions;

window.Account = Account;
window.Timeout = Timeout;
window.Timezone = Timezone;
window.PDS = PDS;
window.MFA = MFA;

// MAA
window.addEventListener("load", PasswordChange.init, false);
window.addEventListener("load", PasswordReset.init, false);
window.addEventListener("load", Export.init, false);
window.addEventListener("load", Forms.init, false);
window.addEventListener("load", ProfileImage.init, false);
window.addEventListener("load", RemoveConnection.init, false);
window.addEventListener("load", PrivateKeyChange.init, false);
window.addEventListener("load", Account.init, false);
window.addEventListener("load", Timeout.init, false);
window.addEventListener("load", Timezone.init, false);
window.addEventListener("load", MFA.init, false);

 
// Create click handlers for cards on a page.
window.addEventListener("load", DataProcessing.load.pds, false);
window.addEventListener("load", PDSTable.init, false);


window.addEventListener("load", Card.init, false);
window.addEventListener("load", Referral.init, false);
window.addEventListener("load", Timeline.init, false);
window.addEventListener("load", Register.init, false);
window.addEventListener("load", Group.init, false);
window.addEventListener("load", Table.init, false);
window.addEventListener("load", Setup.init, false);

window.addEventListener("load", MaMMenu.init, false)
window.addEventListener("load", CheckButtonsMulti.init, false);

window.addEventListener("load", ListAddItems.init, false);
window.addEventListener("load", MyPeople.init, false);
window.addEventListener("load", ProfilePicWideWControls.init, false);
window.addEventListener("load", FileDropper.init, false);
window.addEventListener("load", SmileList.init, false);
window.addEventListener("load", PhoneEntry.init, false);
window.addEventListener("load", ExpandableCard.init, false);
window.addEventListener("load", AddressBook.init, false);
window.addEventListener("load", GalleryUploader.init, false);
window.addEventListener("load", MaMFormHandler.init, false);
window.addEventListener("load", MySupportPackages.init, false);
window.addEventListener("load", MedicalInformation.init, false);
window.addEventListener("load", MyHealthConditions.init, false);

// Add event listener for the JSON datasets
function addJSONReadEventListeners() {
  $('.pds-json-instance').each(function () {
    $(this).click(function () {
      // Get the dataset and the instance from the link we clicked
      var dataset = $(this).attr("data-dataset");
      var instance = $(this).attr("data-instance");
      // Load the data from PDS and display
      DataProcessing.load.displayAllDatasets('/pds-json-read', dataset, null, instance);
    });
  });
}
window.addEventListener("load", addJSONReadEventListeners, false);

// function to handle the Member Account navigation
// We want this to warn members they are leaving the MAA section (and thus will require re-entering their PK)
function addMAANavigationWarning() {
  const currentPath = window.location.pathname;
  let pendingNavigationUrl = null;

  function isMAARoute(path) {
    return path.startsWith('/maa/');
  }

  // Only run if we're currently on a /maa/ page
  if (!isMAARoute(currentPath)) return;

  $('a[href]').on('click', function (e) {

    const targetHref = $(this).attr('href');

    // Ignore internal anchors, JS, or mail links
    if (
      !targetHref ||
      targetHref === '#' ||
      targetHref === '/logout' ||
      targetHref.startsWith('#') ||
      targetHref.toLowerCase().startsWith('javascript:') ||
      targetHref.toLowerCase().startsWith('mailto:')
    ) {
      return;
    }

    const linkUrl = new URL(targetHref, window.location.origin);

    // If staying within /maa/, do nothing
    if (isMAARoute(linkUrl.pathname)) return;

    // Prevent immediate navigation
    e.preventDefault();
    pendingNavigationUrl = linkUrl.href;

    // Show modal instead of confirm()
    $('#manage-maa').modal('show');
  });

  // When user confirms in the modal
  $('#manage-maa').on('click', '.confirm-leave', function () {
    if (pendingNavigationUrl) {
      window.location.href = pendingNavigationUrl;
    }
  });

}

window.addEventListener("load", addMAANavigationWarning, false);